import { request } from "components/utils/Request2";
import { useEffect, useState } from "react";
import { showSnackbar } from "@cofano/cck"; 

const useRequest = <T,>({
	defaultResponse,
	url,
	interval,
	allowed = true,
}: {
	defaultResponse: T;
	url: string;
	interval?: number;
	allowed?: boolean,
}) => {

	const [ response, setResponse ] = useState<T>(defaultResponse);
	const [ loading, setLoading ] = useState(allowed);

	const retrieveData = () => {

		setLoading(true);

		request({
			url: url,
		}).then(r => {
			setResponse(r as T);
		}).catch((error) => {
			if (!error.error && error.response.statusText) {
				showSnackbar(error.response.statusText, { variant: "error" });
			}
		}).finally(() => {
			setLoading(false);
		});
	};

	useEffect(() => {
		let intervalInstance = null;
		if (interval && allowed) {
			intervalInstance = setInterval(() => retrieveData(), interval);
		} else if (allowed) {
			retrieveData();
		}

		return () => {
			if (intervalInstance) {
				clearInterval(intervalInstance);
			}
		};
	}, []);

	return [
		response,
		{
			trigger: () => retrieveData(),
			loading: loading,
		},
	] as [ T, { trigger: () => void, loading: boolean } ];
};

export default useRequest;
